import MessageClassification from 'owa-service/lib/contract/MessageClassification';
import { action } from 'satcheljs';

export default action(
    'ON_MESSAGE_CLASSIFICATION_RESPONSE',
    (messageClassifications: MessageClassification[]) => ({
        messageClassifications,
    })
);
